import { render, staticRenderFns } from "./EditOnRoad.vue?vue&type=template&id=bb27a33c&scoped=true"
import script from "./EditOnRoad.vue?vue&type=script&lang=js"
export * from "./EditOnRoad.vue?vue&type=script&lang=js"
import style0 from "./EditOnRoad.vue?vue&type=style&index=0&id=bb27a33c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb27a33c",
  null
  
)

export default component.exports